import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-600/20 border border-cyan-500/30 hover:bg-cyan-600/30 transition-all duration-300 text-cyan-200 hover:text-cyan-100"
      aria-label="Toggle language"
    >
      <Globe className="w-4 h-4" />
      <span className="font-semibold">{language === 'de' ? 'DE' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;
